const NAVIERA_OPTIONS = ['Maersk', 'MSC', 'ONE', 'COSCO', 'Seatrade', 'CMA CGM', 'Citikold', 'Evergreen', 'Hapag-Lloyd', 'Marglobal', 'Otra'];

const NAVIERA_VOLUME_OPTIONS = [
  'Principal (+60% del volumen)',
  'Relevante (30%-60% del volumen)',
  'Ocasional (-30% del volumen)',
];

const NAVIERA_EVALUATION_CRITERIA = [
  { id: 'availability', label: 'Disponibilidad de espacio/equipo' },
  { id: 'punctuality', label: 'Cumplimiento de itinerarios' },
  { id: 'communication', label: 'Comunicación proactiva' },
  { id: 'resolution', label: 'Resolución de problemas' },
  { id: 'costTransparency', label: 'Transparencia de costos' },
  { id: 'documentation', label: 'Gestión documental' },
  { id: 'overall', label: 'Satisfacción general' },
];

const NAVIERA_PROBLEM_OPTIONS = [
  'Falta de contenedores',
  'Falta de espacio',
  'Roll-over',
  'Blank sailing',
  'Retrasos o cambios de ETA',
  'Cobros inesperados',
  'Mala comunicación',
  'Errores documentales',
  'Mala gestión de reclamos',
  'Sin problemas relevantes',
  'Otro',
];

const NAVIERA_SEVERITY_OPTIONS = [
  'Sin impacto relevante',
  'Bajo',
  'Medio',
  'Alto',
  'Crítico',
];

const NAVIERA_INCIDENT_OPTIONS = ['0', '1', '2-3', '4+'];

const NAVIERA_IMPACT_DAYS_OPTIONS = [
  '0 días',
  '1-2 días',
  '3-5 días',
  '6+ días',
];

const NAVIERA_COST_IMPACT_OPTIONS = [
  'Sin impacto',
  'Menos de USD 500',
  'USD 500 - 2.000',
  'Más de USD 2.000',
  'No cuantificado',
];

const NAVIERA_RESOLUTION_OPTIONS = ['Sí', 'Parcialmente', 'No', 'No aplica'];

const PRICE_TREND_OPTIONS = [
  'Subieron',
  'Se mantuvieron',
  'Bajaron',
  'Mixto / depende de ruta',
];

const NAVIERA_DIAGNOSTIC_CONFIG = {
  maxCarriers: 3,
  carrierOptions: NAVIERA_OPTIONS,
  volumeOptions: NAVIERA_VOLUME_OPTIONS,
  criteria: NAVIERA_EVALUATION_CRITERIA,
  problemOptions: NAVIERA_PROBLEM_OPTIONS,
  severityOptions: NAVIERA_SEVERITY_OPTIONS,
  incidentOptions: NAVIERA_INCIDENT_OPTIONS,
  impactDaysOptions: NAVIERA_IMPACT_DAYS_OPTIONS,
  costImpactOptions: NAVIERA_COST_IMPACT_OPTIONS,
  resolutionOptions: NAVIERA_RESOLUTION_OPTIONS,
};

const BASE_DIMENSIONS = [
  {
    id: 'availability',
    name: 'Disponibilidad Logística',
    weight: 0.25,
    questions: [
      { id: 'd1_q1', text: '¿Cómo calificas la disponibilidad de contenedores según tu necesidad?', type: 'likert', scale: [1, 5], required: true },
      { id: 'd1_q2', text: '¿Cómo calificas el estado de los contenedores respecto al mes anterior?', type: 'likert', scale: [1, 5], required: true },
      { id: 'd1_q3', text: '¿Qué tan fácil fue reservar espacios con las navieras que utilizaste?', type: 'likert', scale: [1, 5], required: true },
      { id: 'd1_q4', text: '¿Qué estrategias has implementado para mitigar problemas de disponibilidad?', type: 'open', required: false },
    ],
  },
  {
    id: 'costs',
    name: 'Costos',
    weight: 0.20,
    questions: [
      { id: 'd2_q1', text: '¿Qué tan justas fueron las tarifas ofrecidas por las navieras en relación con tu volumen?', type: 'likert', scale: [1, 5], required: true },
      {
        id: 'd2_q5',
        text: 'En comparación con el mes anterior, ¿cómo variaron los precios de los servicios navieros?',
        type: 'select',
        options: PRICE_TREND_OPTIONS,
        required: true,
      },
      { id: 'd2_q2', text: '¿Has enfrentado costos adicionales inesperados en los últimos meses?', type: 'binary', positive: 'No', negative: 'Sí', required: true },
      { id: 'd2_q3', text: 'Si hubo costos adicionales, ¿han estado debidamente justificados?', type: 'binary', positive: 'Sí', negative: 'No', required: true },
      { id: 'd2_q4', text: 'Describe cómo han variado tus márgenes debido al precio del flete.', type: 'open', required: false },
    ],
  },
  {
    id: 'reliability',
    name: 'Comunicación y Cumplimiento Naviero',
    weight: 0.35,
    questions: [
      {
        id: 'meta_naviera_principal',
        text: '¿Con qué naviera trabajaste principalmente en este período?',
        type: 'select',
        required: true,
        options: NAVIERA_OPTIONS,
      },
      {
        id: 'meta_naviera_detalle',
        text: 'Radiografía por naviera: evalúa hasta 3 navieras utilizadas en este período.',
        type: 'naviera_diagnostics',
        required: true,
        config: NAVIERA_DIAGNOSTIC_CONFIG,
      },
      {
        id: 'meta_naviera_comentario',
        text: '¿Qué comentario o experiencia destacarías sobre la naviera principal que utilizaste en este período?',
        type: 'open',
        required: false,
      },
      { id: 'd3_q1', text: '¿Qué tan clara es la información de itinerarios y horarios que recibes de las navieras?', type: 'likert', scale: [1, 5], required: true },
      { id: 'd3_q2', text: '¿Cómo evalúas la comunicación de las navieras ante eventos imprevistos o demoras?', type: 'likert', scale: [1, 5], required: true },
      { id: 'd3_q3', text: '¿Qué tan accesibles son las navieras para resolver dudas o problemas?', type: 'likert', scale: [1, 5], required: true },
      { id: 'd3_q5', text: 'En general, ¿cómo calificas la calidad de la comunicación con las navieras?', type: 'likert', scale: [1, 5], required: true },
    ],
  },
  {
    id: 'port',
    name: 'Operación Portuaria',
    weight: 0.10,
    questions: [
      { id: 'd4_q1', text: '¿Los procedimientos aduaneros son predecibles y consistentes?', type: 'likert', scale: [1, 5], required: true },
      { id: 'd4_q2', text: '¿Cómo calificas el manejo de la mercancía en las inspecciones?', type: 'likert', scale: [1, 5], required: true },
      { id: 'd4_q3', text: '¿El personal de inspección está capacitado para tu producto?', type: 'likert', scale: [1, 5], required: true },
      { id: 'd4_q4', text: '¿Cómo evalúas la capacidad operativa de los puertos donde operas?', type: 'likert', scale: [1, 5], required: true },
      { id: 'd4_q5', text: '¿Has experimentado congestión portuaria en los últimos meses?', type: 'binary', positive: 'No', negative: 'Sí', required: true },
      { id: 'd4_q6', text: '¿Los accesos y vías hacia el puerto facilitan el transporte de tu carga?', type: 'likert', scale: [1, 5], required: true },
      { id: 'd4_q7', text: '¿La infraestructura portuaria actual es suficiente para la demanda de tu sector?', type: 'binary', positive: 'Sí', negative: 'No', required: true },
      {
        id: 'd4_q8',
        text: '¿Cuál es el principal puerto que utilizaste en este período?',
        type: 'select',
        required: true,
        options: ['DP World (Posorja)', 'Contecon Guayaquil', 'Terminal Portuario Guayaquil (TPG)', 'Naportec', 'Yilport', 'Puerto de Guayaquil', 'Otros'],
      },
      { id: 'd4_q8_other', text: 'Si seleccionaste "Otros", escribe el puerto utilizado.', type: 'open', required: false },
    ],
  },
  {
    id: 'general',
    name: 'Experiencia General',
    weight: 0.10,
    questions: [
      { id: 'd3_q4', text: '¿Cómo evaluarías el nivel de cumplimiento de las navieras con las que trabajas?', type: 'likert', scale: [1, 5], required: true },
      { id: 'd3_q6', text: '¿Cómo calificas la relación costo-beneficio global de los servicios recibidos?', type: 'likert', scale: [1, 5], required: true },
    ],
  },
];

const questionnaire = {
  dimensions: BASE_DIMENSIONS,
  getAllQuestions() {
    if (!this.dimensionsInitialized) {
      this.dimensions = BASE_DIMENSIONS;
      this.dimensionsInitialized = true;
    }
    return this.dimensions.flatMap((d) => d.questions);
  },
  getDimensions() {
    if (!this.dimensionsInitialized) {
      this.dimensions = BASE_DIMENSIONS;
      this.dimensionsInitialized = true;
    }
    return this.dimensions;
  },
};

export {
  BASE_DIMENSIONS,
  NAVIERA_DIAGNOSTIC_CONFIG,
  NAVIERA_EVALUATION_CRITERIA,
  NAVIERA_OPTIONS,
  NAVIERA_PROBLEM_OPTIONS,
};
export default questionnaire;
